// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"204":"route-travel","344":"route-travelLocation"}[chunkId] + ".chunk." + {"204":"08260","344":"d8242"}[chunkId] + ".js";
};